import BaseHandler from './BaseHandler';
import ProductsCarousel from '../modules/productsCarousel';
import { HANDLERS } from '../constants/globals';

export default class ProductsCarouselHandler extends BaseHandler {
    constructor() {
        super();
        this.elements = [];
        this.instanceList = null;
    };

    init = (optionalContainer) => {
        HANDLERS["productsCarouselHandler"] = this;

        this.elements = this.getElementsByDataInit('productsCarousel', optionalContainer);
        if (!this.elements.length > 0) { return };
        this.instanceList = this.createInstanceListByName('productsCarousel');

        this.elements.forEach((el) => {
            if (this.instanceList.containsElement(el)) { return };
            let productsCarousel = new ProductsCarousel(el);

            if (!el.hasAttribute('id')) el.id = this.createUniqueID('productsCarousel');
            this.instanceList.add(el.id, productsCarousel);
        });
    }

}